export default "__VITE_ASSET__c1c0475a__"